import { getApi } from "./api_instance";

export const getSubCategories = async (logout) => {
  try {
    const { data } = await getApi({
      apiUrl: "/projects/api/subcategories/",
      logout,
    });
    return data;
  } catch (error) {
    return error;
  }
};
